import {
  DECLARATIONS_STATEMENTS_SAVE
} from "../../constants/loan/_declarations_constants";

export const DECLARATIONS_STATEMENTS_SAVE_ACTION = (value) => ({
  type: DECLARATIONS_STATEMENTS_SAVE,
  payload: value
});
